"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TopbarUserDropdownMenu_vue_1 = __importDefault(require("@becrop/components/Common/TopbarUserDropdownMenu.vue"));
const Module_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Module"));
const { MoreVertical } = require('lucide-vue-next');
const floating_vue_1 = require("floating-vue");
const TopBarMenuUser_vue_1 = __importDefault(require("@becrop/components/Common/TopBarMenuUser.vue"));
let TopbarTracking = class TopbarTracking extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.user = null;
        this.defaultValue = '';
    }
    onChangeSearch(s) {
        this.defaultValue = s;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    logOut() {
        window.location.href = '/logout';
    }
    switchModuleFromSwitcher(m) {
        const rawModule = { slug: m };
        const targetModule = new Module_1.default(rawModule);
        targetModule.switchToThisModule();
    }
    async changeLang(lang) {
        this.$JSLang.setLocale(lang);
        localStorage.locale = lang;
        await fetch('/lang/' + lang);
    }
    mounted() {
        if (localStorage.locale === undefined) {
            localStorage.locale = this.$locale.value;
        }
        this.$JSLang.setLocale(localStorage.locale);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TopbarTracking.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TopbarTracking.prototype, "user", void 0);
TopbarTracking = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Topbar: bmk_ui_framework_1.Topbar,
            EcosystemLink: bmk_ui_framework_1.EcosystemLink,
            ActionsSet: bmk_ui_framework_1.ActionsSet,
            ActionsSetItem: bmk_ui_framework_1.ActionsSetItem,
            ProfileWidget: bmk_ui_framework_1.ProfileWidget,
            LanguageSwitcher: bmk_ui_framework_1.LanguageSwitcher,
            MasterSearch: bmk_ui_framework_1.MasterSearch,
            ModuleSwitcher: bmk_ui_framework_1.ModuleSwitcher,
            TopbarUserDropdownMenu: TopbarUserDropdownMenu_vue_1.default,
            LogoutIcon: bmk_ui_framework_1.LogoutIcon,
            SettingsIcon: bmk_ui_framework_1.SettingsIcon,
            MoreVertical,
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            Dropdown: floating_vue_1.Dropdown,
            Button: bmk_ui_framework_1.Button,
            TopBarMenuUser: TopBarMenuUser_vue_1.default,
        },
    })
], TopbarTracking);
exports.default = TopbarTracking;
